import {
  transformerHeroBannerCarousal,
  transformDefault,
  transformMePanel,
  transformPromotionOverview,
  transformResourceOverview,
  transformProductCarousal,
  transformAPointProductCarousal,
} from '../component-transformers';

import { ComponentTransformerRegistry, ComponentType } from './types/propTypes';

const componentTransformerRegistry: ComponentTransformerRegistry = {
  [ComponentType.product_carousal_banner]: transformerHeroBannerCarousal,
  [ComponentType.default]: transformDefault,
  [ComponentType.me_panel]: transformMePanel,
  [ComponentType.promotion_overview]: transformPromotionOverview,
  [ComponentType.resource_overview]: transformResourceOverview,
  [ComponentType.product_carousel]: transformProductCarousal,
  [ComponentType.a_point_product_carousel]: transformAPointProductCarousal,
};

export default componentTransformerRegistry;
